// extracted by mini-css-extract-plugin
module.exports = {"container":"Contact-module--container--x56j1","grid":"Contact-module--grid--2jdqc","cell":"Contact-module--cell--FLPpS"};